export class StudentSearchPreferences {
  columnSettings: ColumnSetting[];
}
export class ColumnSetting {
  name: string;
  regEx: string;
  active: boolean;
}
